import { Divider, Link as MuiLink } from "@mui/material";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import { Link, useLocation } from "react-router-dom";

import BankResetAnnouncement from "web/Layout/BankResetAnnouncement";
import ErrorBoundary from "web/Layout/ErrorBoundary";
import MessagesTrigger from "web/Layout/MainHeader/Shared/MessagesTrigger";
import SearchAutocomplete from "web/Layout/SearchAutocomplete";
import __ from "web/Layout/Translations";

import urls from "web/constants/urls";

import CartTrigger from "../CartTrigger";
import MBHeader from "../MBHeader";
import MainMenu from "../MainMenu";
import mainMenuItemClasses from "../MainMenu/MainMenuItem/mainMenuItem.scss";
import WishlistTrigger from "../WishlistTrigger";
import useHeaderVisibility from "./hooks/useHeaderVisibility";
import classes from "./mainHeaderDashboard.scss";

interface IMainHeaderDashboardProps {
  shouldShowMessage: boolean;
}

const forbiddenPaths = [
  urls.proposals,
  urls.totalRewardStatement,
  urls.companyEvents,
  urls.subscriptions,
];

const MainHeaderDashboard: FC<IMainHeaderDashboardProps> = ({
  shouldShowMessage,
}) => {
  const { pathname } = useLocation();
  const { isVisible } = useHeaderVisibility();

  const shouldHideSecondHeader = forbiddenPaths.some((path) =>
    pathname.startsWith(path)
  );

  return (
      <>
        <MBHeader />
        {!shouldHideSecondHeader && (
          <div
            className={classes.dashboardHeader}
            style={{
              transform: isVisible ? 'translateY(0)' : 'translateY(-100%)',
            }}
          >
            <div className={classes.header}>
            <div className={`containerDashboard ${classes.headerRow}`}>
              <div className={classes.heading}>
                <MuiLink
                  component={Link}
                  to={urls.home}
                  className={mainMenuItemClasses.link}
                  color="inherit"
                  underline="none"
                >
                  <Typography variant="subtitle1" sx={{ py: "11px" }}>
                    {__("Kafeteria")}
                  </Typography>
                </MuiLink>
                <Divider orientation="vertical" flexItem sx={{ pl: 3 }} />
              </div>
              <div className={classes.headerUI}>
                <ErrorBoundary smallTextSize>
                  <SearchAutocomplete className={classes.search} />
                </ErrorBoundary>
                <ul className={classes.list}>
                  <li className={classes.item}>
                    <ErrorBoundary smallTextSize>
                      <MessagesTrigger />
                    </ErrorBoundary>
                  </li>
                  <li className={classes.item}>
                    <ErrorBoundary smallTextSize>
                      <WishlistTrigger />
                    </ErrorBoundary>
                  </li>
                  <li className={classes.item}>
                    <ErrorBoundary smallTextSize>
                      <CartTrigger />
                    </ErrorBoundary>
                  </li>
                </ul>
              </div>
            </div>

            <div className={classes.menuWrapper}>
              <ErrorBoundary smallTextSize>
                <MainMenu />
              </ErrorBoundary>
            </div>
            </div>
          </div>
        )}
        <BankResetAnnouncement shouldShowMessage={shouldShowMessage} />
      </>
  );
};

export default MainHeaderDashboard;
